import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const EditCategoryTopic = () => {
  const [category, setCategory] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [topic, setTopic] = useState("");
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const { id } = useParams();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/topics/${id}`)
      .then((response) => {
        console.log(response);
        setCategoryId(response?.data?.topic?.categoryId);
        setTopic(response?.data?.topic?.topic);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const getCategory = () => {
    axios
      .get(`${API_BASE_URL}/category`)
      .then((resp) => {
        console.log(resp);
        const { data } = resp.data;
        setCategory(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getCategory();
  }, []);

  const handleAddNewCategory = () => {
    navigate("/add-category-topic");
  };

  const handleViewAllCategory = () => {
    navigate("/all-category-topic");
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .put(
        `${API_BASE_URL}/admin/topics/${id}`,
        {
          categoryId,
          topic,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((resp) => {
        alert("Category Topic Updated Successfully!");
        setCategoryId("");
        setTopic("");
        navigate("/all-category-topic");
      })
      .catch((err) => {
        console.log(err);
        alert("Error adding category.");
      });
  };

  return (
    <div id="add-department-inner-wrapper">
      <div className="superheader">
        <div className="departmetHeaderdiv">
          <h5>Category Topic</h5>
          <div className="departmentdiv2">
            <button className="handlenewclass" onClick={handleAddNewCategory}>
              + Add New Category Topic
            </button>
            <button className="allclasses" onClick={handleViewAllCategory}>
              All Category Topics
            </button>
          </div>
        </div>

        <div className="form-school-container">
          <h4 className="department-detail">Add Category Topic</h4>
          <form onSubmit={handleSubmit} className="department-detail-form">
            <div className="new-chapter-form-group">
              <label className="new-chapter-label">Category</label>
              <select
                className="new-chapter-dropdown"
                value={categoryId}
                onChange={(e) => setCategoryId(e.target.value)}
                required
              >
                <option value="">-Select Category-</option>
                {category &&
                  category.map((item, idx) => (
                    <option key={idx} value={item._id}>
                      {item.category}
                    </option>
                  ))}
              </select>
            </div>
            {/* -------------------------------- */}
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Topic</label>
              </div>
              <input
                className="school-class-add-input-tag"
                type="text"
                value={topic}
                onChange={(e) => setTopic(e.target.value)}
                placeholder="Enter Category Topic Name"
                required
              />
            </div>

            <div className="form-school-btns">
              <button className="btn-s" type="submit">
                Update
              </button>
              <button
                className="btn-c"
                type="button"
                onClick={() => navigate(-1)}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditCategoryTopic;
